<fitech-workspace-sensors-chart #sensorsChart [ngClass]="{ hidden: !isCurrentStateActive }"></fitech-workspace-sensors-chart>

<fitech-workspace-sensors-chart-with-alarms #sensorsChartWithAlarms [ngClass]="{ hidden: isCurrentStateActive }"></fitech-workspace-sensors-chart-with-alarms>
